
import { Component, Prop, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../../../../framework/state';
import { getResource } from '../../../../../../framework/client/resource';
import { PurchaseInvoiceRow } from '../../../../../../../common/application/model/PurchaseInvoiceRow';
import { getDatabaseOptions } from '../../../../../../framework/service/options';
import { InvoiceRowType } from '../../../../../../../common/application/model/enums/InvoiceRowType';
import { PurchaseInvoice } from '../../../../../../../common/application/model/PurchaseInvoice';
import { ApplicationResource } from '../../../../../../../common/application/enumeration/ApplicationResource';
import { VehicleContract } from '../../../../../../../common/application/model/VehicleContract';
import { VendorContract } from '../../../../../../../common/application/model/VendorContract';
import { formatCurrency, formatToFinnishDate } from '../../../../../service/helper_service';

@Component({})
export default class VuePurchaseInvoiceRow extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.PURCHASE_INVOICE_ROW;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        purchaseInvoice: {} as PurchaseInvoice,
        row: {} as PurchaseInvoiceRow,
        invoiceRowTypeOptions: [] as { id: string | undefined; label: string }[],
        vehicleContract: {} as VehicleContract,
        vendorContract: {} as VendorContract,
        invoiceRowType: '',
    };

    // Functions
    async mounted() {
        this.local.row = (await getResource<PurchaseInvoiceRow>(this.resourceType, this.id))!!;
        this.local.purchaseInvoice = (await getResource<PurchaseInvoice>(
            ApplicationResource.PURCHASE_INVOICE,
            this.local.row.purchaseInvoiceId,
        ))!!;
        this.local.invoiceRowTypeOptions = await getDatabaseOptions('InvoiceRowType', this);

        if (this.local.row.invoiceRowType) {
            this.local.invoiceRowType = this.getInvoiceRowType(
                this.local.row.invoiceRowType,
                this.local.invoiceRowTypeOptions,
            );
        }

        if (this.local.row.vehicleContractId) {
            this.local.vehicleContract = (await getResource<VehicleContract>(
                ApplicationResource.VEHICLE_CONTRACT,
                this.local.row.vehicleContractId,
            ))!!;
        }

        if (this.local.row.vendorContractId) {
            this.local.vendorContract = (await getResource<VendorContract>(
                ApplicationResource.VENDOR_CONTRACT,
                this.local.row.vendorContractId,
            ))!!;
        }
    }

    private getInvoiceRowType(
        invoiceRowType: InvoiceRowType,
        options: { id: string | undefined; label: string }[],
    ): string {
        const option = options.find((option) => option.id === invoiceRowType);
        return option ? option.label : '-';
    }

    back() {
        this.$router.go(-1);
    }

    edit() {
        this.$router.push(`/purchase-invoice-row/${this.local.row.id}/edit`);
    }

    get isAdmin(): boolean {
        return this.shared.admin;
    }

    formatCurrencyValue(value: number | null | undefined) {
        return formatCurrency(value);
    }

    formatDate(date: string): string {
        if (!date) {
            return '-';
        }
        return formatToFinnishDate(date);
    }
}
